import { createAction, props } from '@ngrx/store';

import { ToastState } from '../reducers/toast.reducer';

const prefix = '[Toast]';

export const loadingToastAction = createAction(
  `${prefix} loading`,
  props<NonNullable<ToastState['options']>>(),
);
export const errorToastAction = createAction(
  `${prefix} error`,
  props<NonNullable<ToastState['options']>>(),
);
export const infoToastAction = createAction(
  `${prefix} info`,
  props<NonNullable<ToastState['options']>>(),
);
export const successToastAction = createAction(
  `${prefix} success`,
  props<NonNullable<ToastState['options']>>(),
);
export const clearToastAction = createAction(`${prefix} clear`);
